import { config } from 'client/hooks/config';
import { Api } from 'common/utils/api';
import { useMutation, useQueryClient } from 'react-query';

export interface UserCompanyUpdateRequest {
    userId: string;
    companyIds: number[];
}

export const useUpsertUserCompanies = () => {
    const { path: updatePath } = config.user.updateCompanies();
    const queryClient = useQueryClient();
    const updateMuation = useMutation((data: UserCompanyUpdateRequest) => Api.post({ path: updatePath, body: data }), {
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: config.user.list().key });
        },
    });
    return {
        updateUserCompanies: updateMuation.mutateAsync,
    };
};
